import { useMemo } from 'react';
import { DefaultValues } from '@Enum/DefaultValues.enum';
import { RequestFormHeader, RequisitionInfo } from '@Types/index';
import { parseDateTime } from '@Utils/transformDateTime';
import RequestType from '@Types/common/RequestTypes';
import useStatusFinderByNum from './useStatusFinderByNum';

export const useRequisitionInfoExistingReq = (
  formData: RequestFormHeader | undefined,
  requestStatus: RequestType
): RequisitionInfo => {
  const { findStatus } = useStatusFinderByNum(requestStatus);

  const requisitionInfo: RequisitionInfo = useMemo(() => {
    if (!formData) {
      return {
        requisitionStatus: '',
        requisitionDate: '',
        requisitionNo: 0,
      };
    }

    const requisitionStatus =
      findStatus(formData.reqStatusId)?.codeDesc ||
      DefaultValues.REQUISITION_STATUS_DEFAULT;

    const output = {
      requisitionStatus,
      requisitionDate: parseDateTime(formData.createdDate),
      requisitionNo: formData.requisitionNo || formData.requestId,
    };
    return output;
  }, [formData, findStatus]);

  return requisitionInfo;
};
